import { services } from '@broadleaf/admin-components';
import { ShortDateTime } from './ShortDateTime';

const { ComponentRegistrar } = services;

ComponentRegistrar.registerComponent('blDateTime', ShortDateTime);
